module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.showSubmit == 1) ? _c('div', {
    staticClass: "live_input"
  }, [_c('div', {
    staticClass: "live_input_content",
    on: {
      "click": function($event) {
        _vm.submitComment()
      }
    }
  }, [_vm._v(" 写点评论吧..")])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d767ef06"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/CommentBox.vue
// module id = 333
// module chunks = 1